export default __webpack_public_path__ + "static/media/liquidity_provider_right_image.e90892f1.png";